import { NgModule } from '@angular/core';
import { AdminEditTextPage } from 'pages/admin-edit-text/admin-edit-text';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [AdminEditTextPage],
    imports: [PagesModule, ComponentsModule],
    exports: [AdminEditTextPage]
})
export class AdminEditTextPageModule {}
